import {
	IImageService,
	IFirebaseService,
} from "../interfaces/services.interfaces";
import { IStationPlanetImage } from "../interfaces/map.interfaces";
import AbstractService from "./abstract.service";
import { env } from "./../env";

export default class ImageService
	extends AbstractService
	implements IImageService
{
	constructor({ firebaseService }: { firebaseService: IFirebaseService }) {
		super({ firebaseService });
	}

	public async uploadImage(file: File, fileName: string): Promise<any> {
		const url = `${env.REACT_APP_SERVER_URL}/image/upload`;
		const form = new FormData();

		form.append("imageFile", file, fileName);
		console.log(form);
		try {
			await this.axiosInstance({
				method: "post",
				url: url,
				data: form,
				headers: { "Content-Type": "multipart/form-data" },
			});
			console.log(`${fileName} uploaded successfully`);
		} catch (error) {
			console.log(error);
			console.error(`Failed to upload ${fileName}`);
		}
	}

	public getRetrieveUrl(eventId: string, key: string, token: string): string {
		const params = new URLSearchParams({
			eventId,
			key,
			token,
		});
		return `${env.REACT_APP_SERVER_URL}/image/retrieve?${params.toString()}`;
	}

	public async getStationPlanetImages(
		eventId: string
	): Promise<IStationPlanetImage[]> {
		const { data } = await this.axiosInstance.get(
			`${env.REACT_APP_SERVER_URL}/image/station_planet/list`,
			{ params: { eventId } }
		);
		return data?.images || [];
	}

	public getStationPlanetImageUrl(
		eventId: string,
		key: string,
		token: string
	): string {
		const params = new URLSearchParams({
			eventId,
			key,
			token,
		});
		return `${env.REACT_APP_SERVER_URL}/image/station_planet/retrieve?${params.toString()}`;
	}
}
